const STORE_NAME = 'metadataTableConfig';

export default {
    name: STORE_NAME,
    namespaced: true,
    state: {
        optionsConfigs: [],
    },
    mutations: {
        createUpdateConfig(state, newConfig) {
            const index = state.optionsConfigs.findIndex(
                (item) => item.tableName === newConfig.tableName
            );
            if (index !== -1) {
                state.optionsConfigs[index] = newConfig;
                Object.assign(state.optionsConfigs[index], newConfig);
            } else {
                state.optionsConfigs = [...state.optionsConfigs, newConfig];
            }
        },
    },
    actions: {
        getConfigByName(state, name) {
            return state.state.optionsConfigs.find((item) => item.tableName === name);
        },
        createUpdateConfig({ commit }, newConfig) {
            commit('createUpdateConfig', newConfig);
        },
    },
    _persistent: {
        getDataToSave: (state) => {
            return {
                optionsConfigs: state[STORE_NAME] ? state[STORE_NAME].optionsConfigs : [],
            };
        },
        getDataToLoad: (data) => {
            return data;
        },
    },
};
